export const black = '#11111f'
export const orange = '#ffb53b'
export const blue = '#0181eb'
export const darkgreen = '#00cc6d'
export const green = '#4eff00'
export const lightgreen = '#00eb7f'
export const linkBorderWeight = '5px'
